import script from "./EnableNotificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnableNotificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./EnableNotificationsPage.vue?vue&type=style&index=0&id=dbb9507c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbb9507c"]])

export default __exports__